import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "reminder",
  "use": "reminder-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"reminder\"><path d=\"M3.869 15a1 1 0 0 1-.833-1.555L4 12V8a6 6 0 1 1 12 0v4l.964 1.445A1 1 0 0 1 16.13 15H13a3 3 0 0 1-6 0H3.869ZM12 15H8l.005.15A2 2 0 0 0 12 15ZM10 3a5 5 0 0 0-5 5v4.303l-.168.252L3.87 14h12.26l-.963-1.445-.168-.252V8a5 5 0 0 0-5-5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol